import { defineMessages } from 'react-intl';

const trns = defineMessages({
  interestedIn: {
    id: '9hqTeH',
    defaultMessage: 'Вас також може зацікавити'
  }
});

export default trns;
